<template>
  <div class="rightTitle">
    <SecondaryTextButton :text="text"></SecondaryTextButton>
  </div>
</template>

<script>

  import SecondaryTextButton from "@/components/buttons/SecondaryTextButton";
  export default {
    name: 'rightTitle',
    components: {SecondaryTextButton},
    props: ['text'],
    data() {
      return {
      }
    },
    methods: {

    },

    created() {
    }
  }
</script>

